<div class="amuted fz12" style="margin-bottom:13px">{{ bk.customer }}<ng-container *ngIf="bk.eventLine"> · {{ bk.eventLine }}</ng-container></div>
<div style="display:flex;gap:7px;flex-wrap:wrap;margin-bottom:14px">
  <span class="apill" [style.background]="bk.statusBg" [style.color]="bk.statusFg">{{ bk.statusLabel }}</span>
</div>

<!-- Packages -->
<div class="acard bkm-card" *ngIf="bk.packages.length">
  <div class="acard-h bkm-h">Packages</div>
  <div class="bkm-pkg" *ngFor="let p of bk.packages">
    <div class="b7 fz12 bkm-pkg-v">
      <span class="apill bkm-partner" *ngIf="p.isPartner">Partner</span> {{ p.vendorName }}
    </div>
    <!-- Flat line breakdown (mockup avBookingDetail pk.lines): base line, then the items
         and add-ons the customer picked inside this package. -->
    <div class="kvrow bkm-kv" *ngFor="let ln of p.lines">
      <span class="k">{{ ln.label }}</span>
      <span class="v" *ngIf="ln.amount !== null">{{ ln.amount | rm }}</span>
    </div>
  </div>
</div>

<!-- Financials · customer escrow -->
<div class="acard bkm-card">
  <div class="acard-h bkm-h">Financials · customer escrow</div>
  <div class="kvrow"><span class="k">Booking total</span><span class="v">{{ bk.total | rm }}</span></div>
  <div class="kvrow"><span class="k">Deposit</span><span class="v">{{ bk.depositPct }}% · {{ bk.deposit | rm }}</span></div>
  <div class="kvrow"><span class="k">In escrow now</span><span class="v" style="color:var(--teal-deep);font-weight:800">{{ bk.inEscrow | rm }}</span></div>
  <div class="kvrow" *ngIf="bk.balanceDue > 0"><span class="k">Balance still due into escrow</span><span class="v" style="color:#B5751A">{{ bk.balanceDue | rm }}</span></div>
  <div class="kvrow"><span class="k">Released from escrow</span><span class="v">{{ bk.released | rm }}</span></div>
  <div class="kvrow"><span class="k">Refunded to customer</span><span class="v">{{ bk.refunded | rm }}</span></div>
</div>

<!-- Per-vendor payout & advances -->
<div class="acard bkm-card" *ngIf="bk.perVendor.length">
  <div class="acard-h bkm-h" style="margin-bottom:2px">Per-vendor payout &amp; advances</div>
  <div class="amuted bkm-note">Each vendor’s own share minus the Trexa fee, plus any early release. Advances are fronted by the guarantee fund (not this escrow) and net from the vendor’s payout when the event completes — so a paid advance is always covered by their payout.</div>
  <div class="bkm-vendor" *ngFor="let v of bk.perVendor">
    <div class="b7 fz12 bkm-vendor-h">
      <span class="apill" [style.background]="v.isReseller ? '#E7F5EF' : '#EDEBFF'" [style.color]="v.isReseller ? '#0B7C8C' : '#6C5CE7'">{{ v.isReseller ? 'Reseller' : 'Partner' }}</span> {{ v.vendorName }}
    </div>
    <div class="kvrow bkm-kv"><span class="k">Own services (their packages)</span><span class="v">{{ v.base | rm }}</span></div>
    <div class="kvrow bkm-kv" *ngIf="v.markup > 0"><span class="k">+ Markup profit (resold partner packages)</span><span class="v" style="color:var(--green)">+ {{ v.markup | rm }}</span></div>
    <!-- Adjustments — named lines (e.g. "Transport", "Discount"). A discount is prefixed "− " and
         shown in RED: on a PAYOUT breakdown it comes out of what the vendor is paid, like the
         platform fee below (mockup release card: "− order adjustment" in #C0392B). The customer
         invoice keeps green, where a discount is good news (QA 2026-10-18). A charge is the plain
         amount, uncoloured.
         Each line is indented with a leading bullet to read as belonging under "Adjustments". -->
    <ng-container *ngIf="v.adjustmentLines.length">
      <div class="kvrow bkm-kv bkm-adj-head">
        <span class="k">Adjustments</span>
        <span class="v" [style.color]="v.adjustments < 0 ? '#C0392B' : null">{{ v.adjustments < 0 ? '− ' : '' }}{{ (v.adjustments < 0 ? -v.adjustments : v.adjustments) | rm }}</span>
      </div>
      <div class="kvrow bkm-kv bkm-adj-line" *ngFor="let l of v.adjustmentLines">
        <span class="k">{{ l.desc }}</span>
        <span class="v" [style.color]="l.negative ? '#C0392B' : null">{{ l.negative ? '− ' : '' }}{{ (l.negative ? -l.amount : l.amount) | rm }}</span>
      </div>
    </ng-container>
    <div class="kvrow bkm-kv"><span class="k">− platform fee {{ v.feePct }}%<span class="amuted" *ngIf="v.markup > 0 || v.adjustmentLines.length"> (on {{ v.gross | rm }})</span></span><span class="v" style="color:#C0392B">− {{ v.fee | rm }}</span></div>
    <div class="kvrow bkm-kv bkm-payout"><span class="k">Payout on completion</span><span class="v">{{ v.net | rm }}</span></div>
    <div class="kvrow bkm-kv"><span class="k">Available early-release headroom</span><span class="v">{{ v.headroom | rm }}</span></div>
    <div class="kvrow bkm-kv" *ngFor="let a of v.advances"><span class="k" [style.color]="a.color">{{ a.label }}</span><span class="v" [style.color]="a.color">{{ a.amount | rm }}</span></div>
    <div class="kvrow bkm-kv bkm-settle" *ngIf="v.leftToSettle !== null"><span class="k">Left to settle on completion</span><span class="v">{{ v.leftToSettle | rm }}</span></div>
  </div>
</div>

<!-- Ledger -->
<div class="acard bkm-card" *ngIf="bk.ledger.length">
  <div class="acard-h bkm-h">Ledger</div>
  <div class="av-led" *ngFor="let r of bk.ledger">
    <div class="av-ledi" [style.background]="r.iconBg" [style.color]="r.iconFg">{{ r.glyph }}</div>
    <div class="led-main">
      <div class="fz13 ell led-title">{{ r.title }}</div>
      <div class="amuted led-sub">{{ r.scope }}<ng-container *ngIf="r.counterparty"> · {{ r.counterparty }}</ng-container> · {{ r.dateLong }}</div>
    </div>
    <div class="led-amount" [style.color]="r.amountColor">{{ r.absAmount | rm }}</div>
  </div>
</div>

<div class="amuted fz12" style="margin-bottom:12px;line-height:1.55" *ngIf="bk.partnerNote">{{ bk.partnerNote }}</div>
<button class="abtn ghost" type="button" style="width:100%" (click)="close.emit()">Close</button>
